"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFullHref = exports.replace = exports.push = exports.createHistory = exports.getHistory = void 0;

var _history3 = require("history");

var _env = require("./env");

var _debug = function _debug() {
  return (0, _env.debug)('history');
};

var history;

var getHistory = function getHistory() {
  return history;
};

exports.getHistory = getHistory;

var createHistory = function createHistory(basename) {
  history = (0, _history3.createBrowserHistory)({
    basename: basename
  });
  return history;
};

exports.createHistory = createHistory;

var push = function push() {
  var _history;

  if (!history) {
    throw new Error('history not initialized');
  }

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (_debug()) {
    var _console;

    console.groupCollapsed('history: push');

    (_console = console).log.apply(_console, ['args:'].concat(args));

    console.groupEnd();
  }

  return (_history = history).push.apply(_history, args);
};

exports.push = push;

var replace = function replace() {
  var _history2;

  if (!history) {
    throw new Error('history not initialized');
  }

  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (_debug()) {
    var _console2;

    console.groupCollapsed('history: replace');

    (_console2 = console).log.apply(_console2, ['args:'].concat(args));

    console.groupEnd();
  }

  return (_history2 = history).replace.apply(_history2, args);
};

exports.replace = replace;

var getFullHref = function getFullHref(to) {
  var includeProtocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!history) {
    throw new Error('history not initialized');
  }

  var _window$location = window.location,
      protocol = _window$location.protocol,
      hostname = _window$location.hostname;
  var location = typeof to === 'string' ? (0, _history3.createLocation)(to, null, null, history.location) : to;
  var href = history.createHref(location);
  return "" + (includeProtocol ? protocol + "//" : '') + hostname + href;
};

exports.getFullHref = getFullHref;


//////////////////
// WEBPACK FOOTER
// ./js/utils/history.js
// module id = 64
// module chunks = 209 210 211 212 213